import { useEffect } from 'react';
import axios from 'axios';

import { getBackendUrl } from '../utils/getBackendUrl';
const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const useBadgeNotifications = (user) => {
  useEffect(() => {
    if (!user || !('setAppBadge' in navigator)) {
      // Badge API not supported or no user logged in
      return;
    }

    const updateBadge = async () => {
      try {
        let totalBadgeCount = 0;

        // Fetch unread notes count
        try {
          const notesResponse = await axios.get(`${API}/user-notes/unread-count`);
          totalBadgeCount += notesResponse.data.count || 0;
        } catch (error) {
          console.error('Failed to fetch unread notes count');
        }

        // For clients: Check for new photos
        if (user.role === 'client') {
          try {
            const photosResponse = await axios.get(`${API}/photos/client/has-new`);
            if (photosResponse.data.has_new) {
              totalBadgeCount += 1; // Add indicator for new photos
            }
          } catch (error) {
            console.error('Failed to fetch photo status');
          }
        }

        // For admins/employees: Check for pending services
        if ((user.role === 'admin' || user.role === 'supervisor') || user.role === 'employee') {
          try {
            const servicesResponse = await axios.get(`${API}/services`);
            const pendingCount = servicesResponse.data.filter(s => s.service_status === 'Pending').length;
            totalBadgeCount += pendingCount;
          } catch (error) {
            console.error('Failed to fetch services count');
          }
        }

        // Set or clear the badge
        if (totalBadgeCount > 0) {
          await navigator.setAppBadge(totalBadgeCount);
        } else {
          await navigator.clearAppBadge();
        }
      } catch (error) {
        console.error('Failed to update app badge:', error);
      }
    };

    // Update immediately
    updateBadge();

    // Update every 60 seconds
    const interval = setInterval(updateBadge, 60000);

    return () => {
      clearInterval(interval);
      // Clear badge when component unmounts
      if ('clearAppBadge' in navigator) {
        navigator.clearAppBadge().catch(() => {});
      }
    };
  }, [user]);
};
